import { Menu } from "primereact/menu";
import { reduzirNome } from "../../utils/reduzirNome";
import Button from "../../componentes/button/button";
import { useMemo, useRef, useState } from "react";
import { formatarMoedaBrasileira } from "../../utils/formatarMoedaBrasileira";

export default function GerenciamentoBPTabela({
  data,
  openModal,
  loading,
  editar,
  verLogs,
  excluir,
  relatorio,
  selectedIds = [],
  setSelectedIds,
  // NOVOS
  excluirEmMassa,
  alterarResponsavelEmMassa,
  sortConfig,
  handleSort,
  isContador
}) {

  const [selectionMode, setSelectionMode] = useState(false);

  // =========================
  // Helpers
  // =========================

  const allIds = useMemo(() => {
    return data?.content?.map((i) => i.id) || [];
  }, [data]);

  const allSelected =
    allIds.length > 0 &&
    allIds.every((id) => selectedIds.includes(id));

  const toggleSelectAll = () => {

    if (allSelected) {
      setSelectedIds([]);
      return;
    }

    setSelectedIds(allIds);
  };

  const toggleRow = (id) => {

    setSelectedIds((prev) => {

      const exists = prev.includes(id);

      if (exists) {
        return prev.filter((i) => i !== id);
      }

      return [...prev, id];
    });
  };

  const disableSelectionMode = () => {
    setSelectionMode(false);
    setSelectedIds([]);
  };

  return (

    <div className="">

      {/* ========================= */}
      {/* TOOLBAR */}
      {/* ========================= */}

  <div className="flex flex-col gap-3 bg-muted px-4 py-3 lg:flex-row lg:items-center lg:justify-between border-top">
        <div className="flex flex-wrap items-center gap-2">
          {!selectionMode ? (
            isContador && (
              <button className="rounded-lg border border-input bg-card px-3 py-2 text-sm font-medium text-foreground shadow-xs transition-colors duration-150 hover:border-primary/40 hover:bg-accent hover:text-accent-foreground" onClick={() => setSelectionMode(true)}>
                <i className="fa fa-check-square mr-2" /> Modo seleção
              </button>
            )
          ) : <>
            <span className="rounded-full bg-accent px-3 py-2 text-xs font-semibold text-accent-foreground ring-1 ring-inset ring-primary/20">{selectedIds.length} selecionado(s)</span>
            <button className="rounded-lg border border-input bg-card px-3 py-2 text-sm font-medium text-foreground transition-colors duration-150 hover:bg-muted" onClick={disableSelectionMode}><i className="fa fa-times mr-2" /> Cancelar</button>
            <button disabled={!selectedIds.length} className="rounded-lg bg-amber-500 px-3 py-2 text-sm font-medium text-white shadow-xs transition-colors duration-150 hover:bg-amber-600 disabled:cursor-not-allowed disabled:opacity-40" onClick={() => alterarResponsavelEmMassa(selectedIds)}><i className="text-xs fa fa-user mr-2" /> Alterar responsável</button>
            <button disabled={!selectedIds.length} className="rounded-lg bg-destructive px-3 py-2 text-sm font-medium text-destructive-foreground shadow-xs transition-colors duration-150 hover:brightness-95 disabled:cursor-not-allowed disabled:opacity-40" onClick={() => excluirEmMassa(selectedIds)}><i className="fa fa-trash text-xs mr-2" /> Excluir selecionados</button>
          </>}
        </div>
        <div className="flex flex-wrap items-center gap-2 text-sm">
          <SummaryCard label="Valor orçado" value={loading ? "–" : `R$ ${formatarMoedaBrasileira(relatorio.totalOrcado)}`} />
          <SummaryCard label="Valor realizado" value={loading ? "–" : `R$ ${formatarMoedaBrasileira(relatorio.totalRealizado)}`} tone="rose" />
        </div>
      </div>

      {/* ========================= */}
      {/* TABELA */}
      {/* ========================= */}

      <div className="overflow-x-auto ">
        <table className="min-w-full divide-y divide-table-border">

          {/* ========================= */}
          {/* HEADER */}
          {/* ========================= */}

          <thead className="bg-table-header">

            <tr className="border-top">

              {/* CHECKBOX HEADER */}
              {selectionMode && (

                <th className="w-10 px-3 py-2">

                  <input
                    type="checkbox"
                    checked={allSelected}
                    onChange={toggleSelectAll}
                    className="
                      w-4
                      h-4
                      rounded
                      border-input
                    "
                  />

                </th>
              )}

              <th
                className="
                  px-3
                  py-2
                  text-left
                  text-xs
                  font-medium
                  text-table-header-fg
                  uppercase
                  tracking-wider
                  cursor-pointer
                "
                onClick={() => handleSort("filial.nome")}
              >
                Filial {" "}
                {sortConfig.key === "filial.nome" &&
                  (sortConfig.direction === "asc" ? "↑" : "↓")}
              </th>

              <th
                className="
                  pl-3
                  py-2
                  text-left
                  text-xs
                  font-medium
                  text-table-header-fg
                  uppercase
                  tracking-wider
                  cursor-pointer
                "
                onClick={() => handleSort("conta.reduzido")}
              >
                Conta {" "}
                {sortConfig.key === "conta.reduzido" &&
                  (sortConfig.direction === "asc" ? "↑" : "↓")}
              </th>

              <th
                className="
                  pr-3
                  py-2
                  text-left
                  text-xs
                  font-medium
                  text-table-header-fg
                  uppercase
                  tracking-wider
                  cursor-pointer
                "
                onClick={() => handleSort("conta.descricao")}
              >
                Descrição {" "}
                {sortConfig.key === "conta.descricao" &&
                  (sortConfig.direction === "asc" ? "↑" : "↓")}
              </th>

              <th
                className="
                  pl-3
                  py-2
                  text-left
                  text-xs
                  font-medium
                  text-table-header-fg
                  uppercase
                  tracking-wider
                  cursor-pointer
                "
                onClick={() => handleSort("centroCusto.codigo")}
              >
                C.C {" "}
                {sortConfig.key === "centroCusto.codigo" &&
                  (sortConfig.direction === "asc" ? "↑" : "↓")}
              </th>

              <th
                className="
                  pr-3
                  py-2
                  text-left
                  text-xs
                  font-medium
                  text-table-header-fg
                  uppercase
                  tracking-wider
                  cursor-pointer
                "
                onClick={() => handleSort("centroCusto.descricao")}
              >
                Descrição {" "}
                {sortConfig.key === "centroCusto.descricao" &&
                  (sortConfig.direction === "asc" ? "↑" : "↓")}
              </th>

              <th
                className="
                  px-3
                  py-2
                  text-left
                  text-xs
                  font-medium
                  text-table-header-fg
                  uppercase
                  tracking-wider
                  cursor-pointer
                "
                onClick={() => handleSort("conta.tipo")}
              >
                Tipo {" "}
                {sortConfig.key === "conta.tipo" &&
                  (sortConfig.direction === "asc" ? "↑" : "↓")}
              </th>

              <th
                className="
                  pr-3
                  py-2
                  text-left
                  text-xs
                  font-medium
                  text-table-header-fg
                  uppercase
                  tracking-wider
                  cursor-pointer
                "
                onClick={() => handleSort("grupo.descricao")}
              >
                Grupo {" "}
                {sortConfig.key === "grupo.descricao" &&
                  (sortConfig.direction === "asc" ? "↑" : "↓")}
              </th>

              <th
                className="
                  px-3
                  py-2
                  text-left
                  text-xs
                  font-medium
                  text-table-header-fg
                  uppercase
                  tracking-wider
                  cursor-pointer
                "
                onClick={() => handleSort("responsavel.nome")}
              >
                Responsável {" "}
                {sortConfig.key === "responsavel.nome" &&
                  (sortConfig.direction === "asc" ? "↑" : "↓")}
              </th>

              <th
                className="
                  px-3
                  py-2
                  text-right
                  text-xs
                  font-medium
                  text-table-header-fg
                  uppercase
                  tracking-wider
                  cursor-pointer
                "
                onClick={() => handleSort("valorTotal")}
              >
                Vl. Orçado {" "}
                {sortConfig.key === "valorTotal" &&
                  (sortConfig.direction === "asc" ? "↓" : "↑")}
              </th>

              <th
                className="
                  px-3
                  py-2
                  text-right
                  text-xs
                  font-medium
                  text-table-header-fg
                  uppercase
                  tracking-wider
                  cursor-pointer
                "
                onClick={() => handleSort("valorTotalRealizadoAtual")}
              >
                Vl. Realizado {" "}
                {sortConfig.key === "valorTotalRealizadoAtual" &&
                  (sortConfig.direction === "asc" ? "↓" : "↑")}
              </th>

              {!selectionMode && (
                <th
                  className="
                    px-3
                    py-2
                    text-center
                    text-xs
                    font-medium
                    text-table-header-fg
                    uppercase
                    tracking-wider
                  "
                >
                  Ações
                </th>
              )}

            </tr>

          </thead>

          {/* ========================= */}
          {/* BODY */}
          {/* ========================= */}

          <tbody
            className={`
              fade-in
              bg-card
              divide-y
              divide-table-border

              ${loading &&
              "opacity-50 pointer-events-none"
              }
            `}
          >

            {data.page.totalElements === 0 ? (

              <tr>

                <td
                  colSpan={selectionMode ? 10 : 9}
                  className="
                    text-center
                    py-4
                    text-muted-foreground
                    text-[12px]
                    text-nowrap
                  "
                >
                  Nenhum registro encontrado
                </td>

              </tr>

            ) : (

              data.content.map((row) => {

                const selected =
                  selectedIds.includes(row.id);

                return (

                  <tr
                    key={row.id}
                    className={`
                      highlight-row
                      hover:bg-table-row-hover
                      transition-colors
                      duration-150

                      ${selected
                        ? "bg-accent"
                        : ""
                      }
                    `}
                  >

                    {/* CHECKBOX */}
                    {selectionMode && (

                      <td className="px-3 py-2">

                        <input
                          type="checkbox"
                          checked={selected}
                          onChange={() => toggleRow(row.id)}
                          className="
                            w-4
                            h-4
                            rounded
                            border-input
                          "
                        />

                      </td>
                    )}

                    <td className="px-3 py-2 text-[12px] text-nowrap text-foreground font-bold">
                      {row.filialNome}
                    </td>

                    <td className="pl-3 py-2 text-[12px] text-nowrap text-foreground">
                      {row.contaReduzido}
                    </td>

                    <td className="pr-3 py-2 text-[12px] text-nowrap text-foreground">
                      {row.contaDescricao}
                    </td>

                    <td className="pl-3 py-2 text-[12px] text-nowrap text-foreground">
                      {row.centroCustoCodigo}
                    </td>

                    <td className="pr-3 py-2 text-[12px] text-nowrap text-foreground">
                      {row.centroCustoDescricao}
                    </td>

                    <td className="px-3 py-2 text-[12px] text-nowrap text-foreground">
                      {row.contaTipo}
                    </td>

                    <td className="px-3 py-2 text-[12px] text-nowrap text-foreground">
                      {row.grupoDescricao}
                    </td>


                    <td className="px-3 py-2 text-[12px] text-nowrap text-foreground">
                      {reduzirNome(row.responsavelNome)}
                    </td>

                    <td className="
                      px-3
                      py-2
                      text-[12px]
                      text-nowrap
                      text-right
                      text-foreground
                    ">
                      {row.valorTotal?.toLocaleString(
                        "pt-BR",
                        {
                          style: "currency",
                          currency: "BRL",
                        }
                      )}
                    </td>

                    <td className="
                      px-3
                      py-2
                      text-[12px]
                      text-nowrap
                      text-right
                      text-foreground
                    ">
                      {row.valorTotalRealizadoAtual?.toLocaleString(
                        "pt-BR",
                        {
                          style: "currency",
                          currency: "BRL",
                        }
                      )}
                    </td>

                    {!selectionMode && (

                      <td>

                        <ActionDropdown
                          row={row}
                          editar={editar}
                          verLogs={verLogs}
                          excluir={excluir}
                          alterarValores={openModal}
                          isContador={isContador}
                        />

                      </td>
                    )}

                  </tr>
                );
              })
            )}

          </tbody>

        </table>

      </div>

    </div>
  );
}

const ActionDropdown = ({
  row,
  alterarValores,
  editar,
  verLogs,
  excluir,
  isContador
}) => {

  const menu = useRef(null);

  const items = [
    {
      label: "Alterar Valores",
      icon: "fa fa-pencil w-4",
      command: () => alterarValores(row)
    },
    ...(isContador
      ? [
          {
            label: "Editar Conta",
            icon: "fa fa-edit w-4",
            command: () => editar(row)
          }
        ]
      : []),
    {
      label: "Visualizar Logs",
      icon: "fa fa-info-circle w-4",
      command: () => verLogs(row)
    },
    ...(isContador
      ? [
          {
            label: "Excluir",
            icon: "fa fa-trash w-4",
            command: () => excluir(row.id)
          }
        ]
      : [])
  ];

  return (

    <div className="flex justify-center py-1">

      <Menu
        model={items}
        popup
        ref={menu}
      />

      <Button
        variant="grayLight"
        iconLeft="fa fa-ellipsis-v"
        onClick={(e) => menu.current.toggle(e)}
      />

    </div>
  );
};

function SummaryCard({ label, value, tone = "slate" }) {
  const tones = tone === "rose" ? "border-destructive/15 bg-destructive/5 text-destructive" : "border-border bg-card text-foreground";
  return <div className={`rounded-lg border px-3 py-2 shadow-xs ${tones}`}><p className="mb-0 text-xs font-medium opacity-70">{label}</p><span className="text-sm font-bold">{value}</span></div>;
}
